var filters = ( function( $ ) {

	var _init = function() {
		$( '.filter-group select' )
			.add( '.post-type-archive-tutor select' )
			.add( '.tax-tutor_expertise select' ).on( 'change', _filter_change );
	};

	var _filter_change = function( event ) {
		var link = $( 'option:selected', this ).data( 'link' );

		if ( link ) {
			$( location ).attr( "href", link );
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = filters;